var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "iframe-resizer", "hypo_bvo/Drklein/ProfilKontaktformular/ProfilKontaktformular.constants", "jquery"], function (require, exports, iframe_resizer_1, ProfilKontaktformular_constants_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.provideFormiAntrag = void 0;
    iframe_resizer_1 = __importDefault(iframe_resizer_1);
    var alreadyLoadedAntraege = [];
    function provideFormiAntrag(produktsparte, $targetElement, agentId) {
        var formiName = ProfilKontaktformular_constants_1.constants.produktspartenLabels[produktsparte].formiName;
        var dankeseiteUrl = "/berater-kontakt-" + produktsparte.toLowerCase() + "-danke.html";
        if (alreadyLoadedAntraege.indexOf(formiName) < 0) {
            alreadyLoadedAntraege.push(formiName);
            var $formiRootElement = $("<iframe />")
                .attr("src", "/apps/formi/" + formiName + "/index.html?berater=" + agentId)
                .attr("data-berater-uid", agentId)
                .attr("data-dankeseite-url", dankeseiteUrl)
                .attr("data-hide-ratenkreditlink", "true")
                .attr("data-no-abbruchlayer", "true")
                .addClass("profilKontaktformular_formiIframe");
            $formiRootElement.appendTo($targetElement);
            (0, iframe_resizer_1.default)({ log: false }, $formiRootElement[0]);
        }
    }
    exports.provideFormiAntrag = provideFormiAntrag;
});
